import React, { useContext, useState } from "react";
import { QuoteContext } from "./QuoteContext";
import { motion, AnimatePresence } from "framer-motion";
import countries from "../../utils/Countries.json";
import { toast } from "react-toastify";

const Residency = () => {
  const { formValues, updateFormValues, nextStep, prevStep, step } =
    useContext(QuoteContext);
  const [residency, setResidency] = useState(formValues.residency || ""); // Track selection
  const [error, setError] = useState(""); // Validation error

  const handleResidencyChange = (e) => {
    setResidency(e.target.value);
    setError(""); // Clear error when user selects
  };

  const handleNext = () => {
    if (!residency) {
      toast.error("Please select your residency.");
      return;
    }

    const selectedCountry = countries.find((country) => country.id === residency);

    if (!selectedCountry) {
      setError("Selected country not found.");
      return;
    }

    updateFormValues({ 
      residency: {
        id: selectedCountry.id,
        country: selectedCountry.country
      }
    });
    nextStep();
  };

  return (
    <div className="text-orangeColor flex items-center justify-center p-10">
      <div className="w-full max-w-lg rounded-lg ">
        <div className="text-white text-[12px] mb-6">
          <span className="bg-[#1f4c75] font-thin px-4 py-1 rounded-full  pointer-events-none cursor-not-allowed">
            Residency
          </span>
        </div>
        <h1 className="text-[26px] sm:text-3xl md:text-4xl font-bold mb-6">
          Residency Information
        </h1>
        <p className="mb-10 text-gray-300 text-[16px] sm:text-[20px]">
          Select your current or future residency.
        </p>

        {/* Residency Selection Dropdown */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="mb-4"
        >
          <label className="text-gray-300 block text-[14px] sm:text-[16px] mb-1">
            Current or Future Residency
          </label>
          <select
            className="block w-full p-2 mb-24 text-[14px] sm:text-[16px] rounded-xl bg-[#001F3F] text-white placeholder-gray-400 border border-gray-500 focus:outline-none focus:ring-2 focus:ring-[#FFA726]"
            value={residency}
            onChange={handleResidencyChange}
          >
            <option value="">Select Residency</option>
            {countries.map((country) => (
              <option key={country.id} value={country.id}>
                {country.country}
              </option>
            ))}
          </select>

          {/* Show error if no selection is made */}
          {error && <p className="text-red-500 mt-2">{error}</p>}
        </motion.div>

        {/* Next & Back Buttons */}
        <div className="flex justify-end gap-6 ">
          {step > 1 && step < 4 && (
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={prevStep}
              className="bg-gray-500 text-white mt-8 py-3 md:py-4 md:px-6 px-4 rounded-xl  hover:bg-gray-600 transition-all"
            >
              Back
            </motion.button>
          )}

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleNext}
            className="bg-orangeColor text-white mt-8 py-3 md:py-4 md:px-6 px-4 rounded-xl  hover:bg-[#ff9800] transition-all"
          >
            Next Step →
          </motion.button>
        </div>
      </div>
    </div>
  );
};

export default Residency;
